module.exports = __webpack_public_path__ + "img/New-Evening_fr.80b13e34.jpg";